/* Preserve full cart lines when a shopper checks out only selected items. */
(function (factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else window.createMeddeyCartRecovery = factory;
})(function createMeddeyCartRecovery(options) {
  'use strict';
  const key = 'meddey_saved_cart_items';
  const cartUrl = options.cartUrl || '/cart';
  const storage = options.storage;
  const identity = item => JSON.stringify([
    Number(item.variant_id || item.id),
    Number(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || 0),
    Object.entries(item.properties || {}).filter(([,value]) => value !== '').sort(([a],[b]) => a.localeCompare(b))
  ]);
  const line = item => {
    const result = { id: Number(item.variant_id || item.id), quantity: Number(item.quantity), properties: item.properties || {} };
    const plan = item.selling_plan_allocation?.selling_plan?.id || item.selling_plan;
    if (plan) result.selling_plan = Number(plan);
    return result;
  };
  async function request(url, body) {
    const response = await options.fetch(url, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Unable to update the cart. Please retry; your saved items have been kept.');
    return response.json();
  }
  const read = () => request(cartUrl + '.js');
  const quantity = (items, target) => items.filter(item => identity(item) === identity(target)).reduce((sum,item)=>sum+Number(item.quantity),0);
  async function restore() {
    const raw = storage.getItem(key);
    if (!raw) return null;
    const saved = JSON.parse(raw);
    const items = Array.isArray(saved) ? saved : saved.items;
    if (!Array.isArray(items) || items.some(item=>!Number.isSafeInteger(Number(item.id)) || Number(item.quantity)<=0)) throw new Error('Saved cart items need attention. Please contact support before clearing your browser data.');
    let cart = await read();
    const missing = items.map(item => ({...line(item),quantity:Math.max(0,Number(item.quantity)-quantity(cart.items,item))})).filter(item=>item.quantity>0);
    if (missing.length) {
      await request(cartUrl + '/add.js', {items:missing});
      cart = await read();
    }
    if (items.some(item=>quantity(cart.items,item)<Number(item.quantity))) throw new Error('Some saved items could not be restored. Please retry.');
    storage.removeItem(key);
    return cart;
  }
  async function prepare(selectedKeys, note) {
    if (storage.getItem(key)) throw new Error('Restore your saved items before starting another checkout.');
    const cart = await read();
    const selected = new Set(selectedKeys);
    if (!selected.size || [...selected].some(k=>!cart.items.some(item=>item.key===k))) throw new Error('Your cart changed. Review the current items and try again.');
    const keep = cart.items.filter(item=>selected.has(item.key));
    const omitted = cart.items.filter(item=>!selected.has(item.key));
    if (!omitted.length) return cart;
    if (omitted.some(item=>keep.some(other=>identity(item)===identity(other)))) throw new Error('Matching items with different discounts must be checked out together.');
    const items = [];
    omitted.forEach(item=>{const existing=items.find(other=>identity(other)===identity(item));if(existing)existing.quantity+=Number(item.quantity);else items.push(line(item));});
    const saved = JSON.stringify({version:2,items});
    storage.setItem(key,saved);
    if (storage.getItem(key)!==saved) throw new Error('Enable browser storage to keep omitted items before using partial checkout.');
    const updates = Object.fromEntries(omitted.map(item=>[item.key,0]));
    await request(cartUrl + '/update.js', {updates,...(typeof note==='string'?{note}:{})});
    const verified = await read();
    if (verified.items.some(item=>!keep.some(other=>identity(other)===identity(item))) || keep.some(item=>quantity(verified.items,item)!==quantity(keep,item))) throw new Error('Your cart changed during checkout. Review it and try again.');
    return verified;
  }
  return {prepare,restore,read};
});
